var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bytedance-button",class:`bytedance-button-${_vm.size}`,on:{"click":_vm.searchJobs}},[_c('span',[_vm._t("default",function(){return [_vm._v("bytedance-button")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }